module.exports = __webpack_public_path__ + "img/status_fail.eaa78805.svg";